"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isWindowsDesktop;

function isWindowsDesktop(userAgent) {
  if (!userAgent) return false;
  var isDesktop = userAgent.indexOf('Windows');
  var isPhone = userAgent.indexOf('Windows Phone');
  return isDesktop > 0 && isPhone === -1; // has to have Windows but exlude Windows Phone
}